import React from 'react';
import './NavbarMobile.css';
import { Link as Anchor, useLocation } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import Cart from '../Cart/Cart'
import Favoritos from '../Favoritos/Favoritos'
import InputSerach from '../InputSerach/InputSearchs'
export default function NavbarMobile() {
    const location = useLocation();

    return (
        <section className='scrolledMobile'>
            <Anchor to={`/`} className={location.pathname === '/' ? 'active' : ''}  >
                <FontAwesomeIcon icon={faHome} />
                <strong>Inicio</strong>

            </Anchor>
            <Cart />
            <Favoritos />
            <InputSerach />


        </section>
    );
}
